import React, { useEffect, useState, useMemo } from "react";
import { PageHeader, Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import { View } from "react-native";
import { getUser } from "../utils/Common";
import Axios from "axios";
import styled from 'styled-components';
import ReservePageLayout from "../components/ReservePageLayout";
import "./reservations.css";

export default function RedyNowReserve(props) {
    const [fullName, setFullName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [qtyJobSight, setQtyJobSight] = useState(0); // 2-cam
    const [qtyJobSightPro, setQtyJobSightPro] = useState(0); // 4-cam
    const [isLoading, setIsLoading] = useState(false);
    const [contractUrl, setContractUrl] = useState(null);
    const [loadiFrame, setLoadiFrame] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const totalCameras = useMemo(() => (qtyJobSight) + (qtyJobSightPro), [qtyJobSight, qtyJobSightPro]);
    
    const buttonText = useMemo(() => {
        return isLoading ? 'Loading Agreement...' : 'Next';
    }, [isLoading]);


    function adjustQuantity(type, unit, current) {
        const cameraCount = 1;
        const currentCameras = (qtyJobSight) + (qtyJobSightPro);
        
        if (type === 'increment') {
            if (currentCameras + cameraCount <= 5) {
                if (unit === 'jobsight') {
                    setQtyJobSight(current + 1);
                } else {
                    setQtyJobSightPro(current + 1);
                }
            }
        } else if (type === 'decrement' && current > 0) {
            if (unit === 'jobsight') {
                setQtyJobSight(current - 1);
            } else {
                setQtyJobSightPro(current - 1);
            }
        }
    }

    useEffect(() => {
        function onMessage(params) {
            if(params.origin !== "https://app.boldsign.com") {
                return;
            } else {
                switch(params.data.action) {
                    case "onDocumentSigned":
                        setLoadiFrame(false);
                        // persist context used by the Success page
                        sessionStorage.setItem('documentId', JSON.stringify(documentId));
                        sessionStorage.setItem('businessName', JSON.stringify(companyName));
                        sessionStorage.setItem('customerName', JSON.stringify(fullName));
                        // navigate to checkout step with state
                        props.history.push({
                            pathname: '/reserve/ready/checkout',
                            state: {
                                fullName,
                                companyName,
                                email,
                                phone,
                                qtyJobSight,
                                qtyJobSightPro,
                                documentId
                            }
                        });
                        break;
                    default:
                        setLoadiFrame(false);
                        break;
                }
            }
        }
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, [companyName, documentId, email, fullName, phone, props.history]);

    async function startSigning(e) {
        e.preventDefault();
        setIsLoading(true);
        try {
            const url = `${process.env.REACT_APP_PAY_URL}/embedded-signing`;
            const response = await Axios.post(url, {
                signerEmail: email,
                fullName: fullName,
                businessName: companyName,
            }, { headers: { 'Content-Type': 'application/json' } });
            setContractUrl(response.data.signLink);
            setDocumentId(response.data.docId);
            setLoadiFrame(true);
            setIsLoading(false);
        } catch(error) {
            console.log(error);
            setIsLoading(false);
        }
    }

	function renderBadAccess() {
		props.history.push(`/dashboard`)
	}

	function renderContent() {
        if(loadiFrame && contractUrl) {
            return (
                <View>
                    {/* <PageHeader>
                        Sign Agreement
                    </PageHeader> */}
                    <View style={{flex:1,flexDirection:"row",justifyContent:"center"}}>
                        <View style={{width:"100%"}}>
                            <iframe title="boldsign" src={contractUrl} className="signer" style={{width:"100%",height:"80vh",border:"0"}} />
                        </View>
                    </View>
                </View>
            );
        }
        return (
            <View>
                <div className="reservation-page-header">
                    <PageHeader>
                        We need a little more information
                    </PageHeader>
                </div>
                <View style={{flex:1,flexDirection:"row",justifyContent:"center"}}>
                    <form className="reservation-width-standard" onSubmit={(e) => startSigning(e)}>
                        <View style={{flex:1, flexDirection:"column"}}>
                            <View style={{flex:1, flexDirection:"row"}}>
                                <View style={{flex:1,flexDirection:"row"}}>
                                    <FormGroup controlId="fullName" bsSize="large" style={{width:"100%"}}>
                                        <ControlLabel>Full Name</ControlLabel>
                                        <FormControl value={fullName} onChange={e => setFullName(e.target.value)} />
                                    </FormGroup>
                                </View>
                                <View style={{flex:1, flexDirection:"row",paddingLeft:"40px"}}>
                                    <FormGroup controlId="companyName" bsSize="large" style={{width:"100%"}}>
                                        <ControlLabel>Company Name</ControlLabel>
                                        <FormControl value={companyName} onChange={e => setCompanyName(e.target.value)} />
                                    </FormGroup>
                                </View>
                            </View>
                            <View style={{flex:1, flexDirection:"row"}}>
                                <View style={{flex:1, flexDirection:"row"}}>
                                    <FormGroup controlId="phone" bsSize="large" style={{width:"100%"}}>
                                        <ControlLabel>Phone</ControlLabel>
                                        <FormControl type="tel" value={phone} onChange={e => setPhone(e.target.value)} />
                                    </FormGroup>
                                </View>
                                <View style={{flex:1,flexDirection:"row",paddingLeft:"40px"}}>
                                    <FormGroup controlId="email" bsSize="large" style={{width:"100%"}}>
                                        <ControlLabel>Email</ControlLabel>
                                        <FormControl type="email" value={email} onChange={e => setEmail(e.target.value)} />
                                    </FormGroup>
                                </View>
                            </View>
                            <View style={{flex:1, flexDirection:"row"}}>
                                <View style={{flex:1, flexDirection:"row"}}>
                                    <FormGroup controlId="qtyJobSight" bsSize="large" style={{width:"100%"}}>
                                        <ControlLabel>JobSight (2-cam) Quantity @ $300/month</ControlLabel>
                                        <div className="quantity-adjuster">
                                            <button 
                                                type="button"
                                                className="quantity-button"
                                                onClick={() => adjustQuantity('decrement', 'jobsight', qtyJobSight)}
                                                disabled={qtyJobSight === 0}
                                            >
                                                −
                                            </button>
                                            <div className="quantity-display">{qtyJobSight}</div>
                                            <button 
                                                type="button"
                                                className="quantity-button"
                                                onClick={() => adjustQuantity('increment', 'jobsight', qtyJobSight)}
                                                disabled={totalCameras >= 5}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </FormGroup>
                                </View>
                                <View style={{flex:1,flexDirection:"row",paddingLeft:"40px"}}>
                                    <FormGroup controlId="qtyJobSightPro" bsSize="large" style={{width:"100%"}}>
                                        <ControlLabel>JobSight PRO (4-cam) Quantity @ $450/month</ControlLabel>
                                        <div className="quantity-adjuster">
                                            <button 
                                                type="button"
                                                className="quantity-button"
                                                onClick={() => adjustQuantity('decrement', 'pro', qtyJobSightPro)}
                                                disabled={qtyJobSightPro === 0}
                                            >
                                                −
                                            </button>
                                            <div className="quantity-display">{qtyJobSightPro}</div>
                                            <button 
                                                type="button"
                                                className="quantity-button"
                                                onClick={() => adjustQuantity('increment', 'pro', qtyJobSightPro)}
                                                disabled={totalCameras >= 5}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </FormGroup>
                                </View>
                            </View>
                            {totalCameras == 5 && (
                                <div className="quantity-total-text">
                                    Reached maximum quantity of 5 cameras with promotion
                                </div>
                            )}
                            <View style={{flex:1, flexDirection:"row",justifyContent:"center"}}>
                                <Button
                                    block
                                    type="submit"
                                    bsSize="large"
                                    className={!isLoading && fullName!=="" && email!=="" && companyName!=="" && phone!=="" && (qtyJobSight+qtyJobSightPro)>0 ? "reservation-submit-button-ready" : ""}
                                    disabled={isLoading || fullName==="" || email==="" || companyName==="" || phone==="" || (qtyJobSight+qtyJobSightPro)===0}
                                >
                                    {buttonText}
                                </Button>
                            </View>
                            <div style={{paddingTop:"10px"}}>
                                <Button bsSize="large" onClick={() => props.history.push('/reserve')}>Back</Button>
                            </div>
                        </View>
                    </form>
                </View>
            </View>
        );
	}

	return (
		<ReservePageLayout handleLogout={props.handleLogout}>
			{getUser().role==="PAYMENTS" || getUser().role==="ADMIN" ? renderContent() : renderBadAccess()}
		</ReservePageLayout>
	);
}


